import {useContext} from "react";
import QRCodeStyleDialogContext from "./QRCodeStyleDialogContext";
import QRCodeStyleView from "./view/QRCodeStyleView";
import BaseModal from "../../../_utils/modals/base/BaseModal";

/**
 * Dialog to pick, edit QRCodeStyle and icons
 * @since 0.1.9
 * @author Kacper Faber
 */
function QRCodeStyleDialog() {
    /**
     * QRCodeStyleDialogContext
     * @context QRCodeStyleDialogContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const ctx = useContext(QRCodeStyleDialogContext);

    return (
        <BaseModal opened={ctx.isOpened} onClose={ctx.close}>
            <QRCodeStyleView
                qrCodeId={ctx.qrCode?.id}
            />
        </BaseModal>
    );
}

// noinspection JSUnusedGlobalSymbols
export default QRCodeStyleDialog;

// TODO: QRCodeStyleDialog
//  I guess I need to create separated dialogs [update, create, assign to the QR]